import { render, staticRenderFns } from "./ticketMessageInput.vue?vue&type=template&id=44b2e550&scoped=true&"
import script from "./ticketMessageInput.vue?vue&type=script&lang=js&"
export * from "./ticketMessageInput.vue?vue&type=script&lang=js&"
import style0 from "./ticketMessageInput.vue?vue&type=style&index=0&id=44b2e550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b2e550",
  null
  
)

export default component.exports